import * as tslib_1 from "tslib";
import PhrasePill from './PhrasePill';
import addPhraseToClause from '../actions/helpers/addPhraseToClause';
import removePhraseFromClause from '../actions/helpers/removePhraseFromClause';
import setClauseErrorText from '../actions/helpers/setClauseErrorText';
import setIncludesWordsInputText from '../actions/helpers/setIncludesWordsInputText';
import store from '../store/store';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
var styles = require('./IncludesWordsInput.scss');
var classNames = require('classnames/bind').bind(styles);
var IncludesWordsInputComputedState = /** @class */ (function () {
    function IncludesWordsInputComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(IncludesWordsInputComputedState.prototype, "isFocused", {
        get: function () {
            return store.inboxRulesEditState.focusedClauseId == this.props.clauseId;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], IncludesWordsInputComputedState.prototype, "isFocused", null);
    return IncludesWordsInputComputedState;
}());
var IncludesWordsInput = /** @class */ (function (_super) {
    tslib_1.__extends(IncludesWordsInput, _super);
    function IncludesWordsInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onInputChange = function () {
            setIncludesWordsInputText(_this.props.clauseId, _this.inputRef.value);
        };
        _this.onKeyDown = function (evt) {
            var clauseId = _this.props.clauseId;
            var inputText = store.inboxRulesEditState.includesWordsInputTextMap.get(clauseId);
            switch (evt.keyCode) {
                case 13 /* Enter */:
                    evt.stopPropagation();
                    if (_this.isValidInput(inputText)) {
                        // clear the error text in case the user is creating their first pill while the error state is shown
                        setClauseErrorText(clauseId, true /*isValidClause*/);
                        addPhraseToClause(clauseId, inputText, 'Keyboard');
                    }
                    break;
                case 8 /* Backspace */:
                    evt.stopPropagation();
                    if (!inputText) {
                        _this.removeLastPhraseFromClause(clauseId, inputText);
                    }
                    break;
            }
        };
        _this.onBlur = function () {
            var inputText = store.inboxRulesEditState.includesWordsInputTextMap.get(_this.props.clauseId);
            if (_this.isValidInput(inputText)) {
                addPhraseToClause(_this.props.clauseId, inputText, 'Blur');
            }
            _this.props.onBlur();
        };
        _this.computedState = new IncludesWordsInputComputedState(_this.props);
        return _this;
    }
    IncludesWordsInput.prototype.focus = function () {
        this.inputRef.focus();
    };
    IncludesWordsInput.prototype.render = function () {
        var _this = this;
        var clauseId = this.props.clauseId;
        var selectedClause = store.inboxRulesEditState.clauseMap.get(clauseId);
        var errorText = store.inboxRulesEditState.clauseErrorTextMap.get(clauseId);
        var committedPhrases = selectedClause.clauseValue;
        var inputContainerClassName = classNames(styles.includesWordsInputContainer, this.computedState.isFocused &&
            this.inputRef == document.activeElement &&
            styles.inputFocused, errorText && styles.hasError);
        return (React.createElement("div", { className: styles.includesWordsContainer },
            React.createElement("div", { className: inputContainerClassName },
                this.renderCommittedPhrases(committedPhrases),
                React.createElement("input", { ref: function (ref) { return (_this.inputRef = ref); }, onFocus: this.props.onFocus, onBlur: this.onBlur, className: styles.phraseInput, value: store.inboxRulesEditState.includesWordsInputTextMap.get(clauseId), placeholder: committedPhrases.length > 0 ? '' : this.props.placeHolderText, onChange: this.onInputChange, onKeyDown: this.onKeyDown })),
            errorText && React.createElement("span", { className: styles.invalidInput }, errorText)));
    };
    IncludesWordsInput.prototype.renderCommittedPhrases = function (committedPhrases) {
        var _this = this;
        var phrasePills = [];
        if (committedPhrases.length > 0) {
            committedPhrases.forEach(function (phrase) {
                phrasePills.push(React.createElement(PhrasePill, { key: phrase, clauseId: _this.props.clauseId, phrase: phrase }));
            });
        }
        return phrasePills;
    };
    IncludesWordsInput.prototype.isValidInput = function (inputText) {
        // if user presses enter with empty input or only whitespace, input is invalid
        return inputText && inputText.trim().length > 0;
    };
    IncludesWordsInput.prototype.removeLastPhraseFromClause = function (clauseId, phrase) {
        var existingPhrases = store.inboxRulesEditState.clauseMap.get(clauseId)
            .clauseValue;
        // if there are no phrases to delete (if a user presses backspace on an empty input), do nothing
        if (!existingPhrases || existingPhrases.length == 0) {
            return;
        }
        removePhraseFromClause(this.props.clauseId, existingPhrases[existingPhrases.length - 1]);
    };
    IncludesWordsInput = tslib_1.__decorate([
        observer
    ], IncludesWordsInput);
    return IncludesWordsInput;
}(React.Component));
export default IncludesWordsInput;
//# sourceMappingURL=IncludesWordsInput.js.map